import type { Session, User } from "@supabase/supabase-js";

export const ACTIONS = {
  SET_SESSION: "set_session",
  SET_USER: "set_user",
  SET_LOADING: "set_loading",
  SET_INITIAL_AUTH_CHECKED: "set_initial_auth_checked",
  SET_INITIAL_SESSION: "set_initial_session",
  SET_RECOVERY_PASSWORD: "set_recovery_password",
  SET_SHOULD_BLOCK: "set_should_block",
  SET_INIT_UPDATE_PASSWORD_FLOW: "set_init_update_password_flow",
} as const;

export type AuthState = {
  session: Session | null;
  user: User | null;
  loading: boolean;
  initialAuthChecked: boolean;
  recoveryPassword: boolean;
};

export type AuthAction =
  | { type: typeof ACTIONS.SET_SESSION; payload: Session | null }
  | { type: typeof ACTIONS.SET_USER; payload: User | null }
  | { type: typeof ACTIONS.SET_LOADING; payload: boolean }
  | { type: typeof ACTIONS.SET_INITIAL_AUTH_CHECKED; payload: boolean }
  | {
      type: typeof ACTIONS.SET_INITIAL_SESSION;
      payload: {
        session: Session | null;
        user: User | null;
        loading: boolean;
        initialAuthChecked: boolean;
      };
    }
  | { type: typeof ACTIONS.SET_RECOVERY_PASSWORD; payload: boolean }
  | { type: typeof ACTIONS.SET_SHOULD_BLOCK; payload: boolean }
  | { type: typeof ACTIONS.SET_INIT_UPDATE_PASSWORD_FLOW };

export default function AuthReducer(state: AuthState, action: AuthAction): AuthState {
  if (action.type === ACTIONS.SET_SESSION) {
    return {
      ...state,
      session: action.payload,
    };
  }
  if (action.type === ACTIONS.SET_USER) {
    return {
      ...state,
      user: action.payload,
    };
  }
  if (action.type === ACTIONS.SET_LOADING) {
    return {
      ...state,
      loading: action.payload,
    };
  }
  if (action.type === ACTIONS.SET_INITIAL_AUTH_CHECKED) {
    return {
      ...state,
      initialAuthChecked: action.payload,
    };
  }
  if (action.type === ACTIONS.SET_INITIAL_SESSION) {
    return {
      ...state,
      session: action.payload.session,
      user: action.payload.user,
      loading: action.payload.loading,
      initialAuthChecked: action.payload.initialAuthChecked,
    };
  }
  if (action.type === ACTIONS.SET_RECOVERY_PASSWORD) {
    return {
      ...state,
      recoveryPassword: action.payload,
    };
  }
  if (action.type === ACTIONS.SET_INIT_UPDATE_PASSWORD_FLOW) {
    return {
      ...state,
      loading: true,
      recoveryPassword: false,
    };
  }
  throw Error("Unknown action.");
}
